var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart2Walker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "37px",
    viewBox: "0 0 36 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-13.3%",
    width: "133.3%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-50.0%",
    y: "-32.5%",
    width: "200.0%",
    height: "165.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-6",
    transform: "translate(-427.000000, -165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(430.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFBD33",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "one-man-walking-copy",
    filter: "url(#filter-3)",
    transform: "translate(9.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5283509,10.1017204 L9.95047368,8.69892473 C9.78512281,8.60903226 9.58533333,8.36967742 9.53150877,8.19698925 L8.73303509,5.63526882 C8.71319298,5.5711828 8.68308772,5.51397849 8.64614035,5.46365591 C8.53005263,5.26236559 8.30631579,5.1255914 8.047,5.1255914 L4.63849123,5.26430108 C4.48910526,5.27032258 4.35021053,5.32365591 4.23640351,5.41204301 C4.21359649,5.42516129 4.18987719,5.43784946 4.16935088,5.45268817 L1.85329825,7.13698925 C1.58577193,7.3316129 1.43592982,7.72731183 1.5125614,8.03763441 L2.42963158,11.7580645 C2.50603509,12.0686022 2.82122807,12.3030108 3.16219298,12.3030108 C3.18522807,12.3030108 3.20849123,12.3019355 3.23152632,12.2997849 L3.57385965,12.2675269 C3.75722807,12.2501075 3.92280702,12.1623656 4.0277193,12.0264516 C4.13285965,11.8905376 4.17094737,11.7150538 4.13240351,11.5451613 L3.48035088,8.67311828 C3.44614035,8.52236559 3.53280702,8.29935484 3.66235088,8.20537634 L4.07492982,7.90580645 L4.28703509,12.5174194 C4.28726316,12.5223656 4.28885965,12.5268817 4.28931579,12.531828 L3.34784211,14.5008602 C3.22924561,14.7488172 2.93138596,15.0922581 2.69738596,15.2511828 L0.490122807,16.7496774 C0.134561404,16.9909677 0.000228070175,17.4735484 0.184052632,17.8486022 L0.486017544,18.463871 C0.606438596,18.7092473 0.847964912,18.8617204 1.11663158,18.8617204 C1.27035088,18.8617204 1.4215614,18.8124731 1.55384211,18.7197849 L4.46812281,16.6735484 C4.75845614,16.4696774 5.11652632,16.0729032 5.28324561,15.7698925 L6.73810526,13.1277419 C6.74973684,13.1064516 6.75703509,13.0836559 6.76661404,13.0615054 L6.86810526,13.0574194 L9.24938596,19.247957 C9.41747368,19.6849462 9.86585965,19.9787097 10.3651053,19.9787097 C10.4837018,19.9787097 10.6009298,19.9617204 10.7135965,19.927957 L10.8604737,19.883871 C11.1514912,19.7967742 11.3852632,19.608172 11.5189123,19.3526882 C11.6523333,19.0972043 11.6685263,18.8073118 11.5645263,18.5367742 L9.05689474,12.0182796 C9.04526316,11.988172 9.02929825,11.9606452 9.01538596,11.932043 L8.93487719,10.1827957 L11.6995439,11.5369892 C11.7967018,11.5847312 11.9061754,11.6098925 12.0163333,11.6098925 C12.2722281,11.6098925 12.5064561,11.4793548 12.6275614,11.2692473 L12.792,10.9836559 C12.970807,10.6737634 12.8524386,10.2780645 12.5283509,10.1017204 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96677193,4.66086022 C6.00257895,4.66086022 6.03884211,4.66021505 6.07510526,4.65870968 C6.73445614,4.63182796 7.34340351,4.36408602 7.78950877,3.90537634 C8.23561404,3.44666667 8.46550877,2.85139785 8.437,2.22967742 C8.37815789,0.945591398 7.24008772,-0.0535483871 5.86094737,0.00215053763 C5.20159649,0.0290322581 4.59264912,0.296774194 4.14654386,0.755483871 C3.7004386,1.2144086 3.47054386,1.80946237 3.49905263,2.4311828 C3.55652632,3.68150538 4.64054386,4.66086022 5.96677193,4.66086022 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2Walker);
export default __webpack_public_path__ + "static/media/chart2-walker.8365bdf7a42d8f8d83889da2405c996e.svg";
export { ForwardRef as ReactComponent };